import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  anomalyChart: {
    boxShadow: 'none',
    width: '100%',
    '& > div': {
      '& path:last-of-type': {
        strokeDasharray: '1',
      },
    },
    marginTop: '10px',
  },
  isLoading: {
    color: colors.lightGray,
  },
  tooltipContainer: {
    '& > div:first-of-type': {
      background: colors.gray,
      color: colors.white,
    },
    '& > div:last-of-type::after': {
      background: colors.gray,
    },
  },
  labelContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    paddingBottom: '0',
    marginBottom: '-20px',
    '& > li': {
      width: 'auto',
    },
  },
  labelText: {
    '& > span': {
      whiteSpace: 'nowrap',
      color: colors.chartLegend,
      fontWeight: fonts.weights.normal,
      fontSize: fonts.sizes.medium,
      letterSpacing: '0.25px',
      lineHeight: '20px',
    },
  },
  labelMarker: {
    display: 'none',
  },
  barLabel: {
    color: colors.chartLegend,
    fontWeight: fonts.weights.medium,
    fontSize: fonts.sizes.small,
  },
});

export default useStyles;
